module.exports = __webpack_public_path__ + "static/img/img14.7065609.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img14.jpg
// module id = Tk+C
// module chunks = 1